import { atom } from "recoil";

export const autoIdpAuthLoadingAtom = atom({ key: "AutoIdpAuthLoadingAtom", default: false });
